/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["textarea{height:100%!important}.fixed-height[_ngcontent-%COMP%]{height:20vh;max-height:20vh}.fixed-height-scroll[_ngcontent-%COMP%]{overflow-y:scroll!important;overflow:auto!important}"];
export { styles as styles };
